import React, { useEffect, useMemo, useRef } from 'react';
import { SelectInstance } from 'react-select';
import { ReactSelectMenu } from '../../../../../../Dropdown/StyledReactSelect';
import { IReactSelectOption } from '../../../../../../../utils/types';
import { colors } from '../../../../../../../config/styles';
import { IOperandValue } from '../../../../../types';
import { createBasicFieldValue } from '../../../../../utils/createBasicFieldValue';

interface IProps {
  value: string;
  relOpValues: string[];
  onChange: (fieldValue: IOperandValue | null) => void;
  placeholder: string;
  autoFocus?: boolean;
  disabled?: boolean;
  hasError: boolean;
}

const PredicateRelValueMenu = ({
  value,
  relOpValues,
  onChange,
  placeholder,
  autoFocus,
  disabled,
  hasError,
}: IProps) => {
  const ref = useRef<SelectInstance<IReactSelectOption>>(null);

  const options = useMemo(
    () =>
      relOpValues.map((val) => ({
        label: val,
        value: val,
      })),
    [relOpValues],
  );

  const handleChange = (newValue: IReactSelectOption | null) => {
    onChange(newValue?.value ? createBasicFieldValue(newValue.value) : null);
  };

  const selectedValue: IReactSelectOption | null = useMemo(() => {
    if (!value) {
      return null;
    }

    return {
      label: value,
      value,
    };
  }, [value]);

  useEffect(() => {
    if (!disabled && autoFocus) {
      ref?.current?.focus();
    }
  }, [autoFocus, disabled]);

  return (
    <ReactSelectMenu
      ref={ref}
      value={selectedValue}
      options={options}
      onChange={handleChange}
      placeholder={placeholder}
      isMulti={false}
      isSearchable={false}
      isClearable
      isDisabled={disabled}
      openMenuOnFocus
      blurInputOnSelect
      hideSelectedOptions
      styles={{
        control: (base) => {
          const result = {
            ...base,
            minWidth: '100%',
            maxWidth: '100%',
          };

          if (hasError) {
            result.borderColor = colors.mainError;
          }

          return result;
        },
      }}
      menuPortalTarget={document.body}
    />
  );
};

export default PredicateRelValueMenu;
